import { Observable } from 'rxjs/Observable';

export const COURRIEL_CLEAR_SEARCH = 'COURRIEL_CLEAR_SEARCH';
export const COURRIEL_SEARCH = 'COURRIEL_SEARCH';
export const COURRIEL_SEARCH_SUCCESS = 'COURRIEL_SEARCH_SUCCESS';
export const COURRIEL_ERROR = 'COURRIEL_ERROR';

export const CourrielActions = {
    /*clear: ({ id, errorCallback }) => {
        return {
            type: 'xxx',
            payload: { id, errorCallback },
        };
    },*/
    clearSearch: ({ errorCallback }) => {
        return {
            type: COURRIEL_CLEAR_SEARCH,
            payload: { errorCallback },
        };
    },

    search: ({ http, model, form, params, errorCallback }) => {
        return {
            type: COURRIEL_SEARCH,
            payload: { http, model, form, params, errorCallback }
        };
    },

    /*create: ({ http, model, form, params, successCallback, errorCallback }) => {
        return {
            type: 'xxx',
            payload: { http, model, form, params, successCallback, errorCallback }
        };
    },

    update: ({ http, model, form, params, successCallback, errorCallback }) => {
        return {
            type: 'xxx',
            payload: { http, model, form, params, successCallback, errorCallback }
        };
    },

    delete: ({ http, model, params, successCallback, errorCallback }) => {
        return {
            type: 'xxx',
            payload: { http, model, params, successCallback, errorCallback }
        };
    },

    openEdit: ({ http, professeur, disponibilite, params, errorCallback }) => {
        return {
            type: 'xxx',
            payload: { http, professeur, disponibilite, params, errorCallback }
        };
    },

    openShow: ({ http, professeur, disponibilite, cours, params: { basicParams, coursParams }, errorCallback }) => {
        return {
            type: 'xxx',
            payload: { http, professeur, disponibilite, cours, params: { basicParams, coursParams }, errorCallback }
        };
    }*/
};

export const CourrielEpics = [
    // SEARCH COURRIEL
    ($action, store) => {
        return $action.ofType(COURRIEL_SEARCH).mergeMap(action => {
            const { http, model, form, params, errorCallback } = action.payload;
            const stream = model.getResource('default', 'find').call(http, form, []);
            return stream
                .map(data => {
                    return {
                        type: COURRIEL_SEARCH_SUCCESS,
                        payload: data,
                    };
                })
                .catch((error) => {
                    errorCallback(error);
                    return Observable.of({
                        type: COURRIEL_ERROR,
                        error
                    });
                });
        });
    }
];

const initialState = {
    loading: false,
    show: null,
    edit: null,
    list: null,
    searchForm: null,
};

export const CourrielReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case COURRIEL_CLEAR_SEARCH:
            return {
                ...state,
                loading: false,
                searchForm: null,
                list: null,
            };
        case COURRIEL_SEARCH:
            return {
                ...state,
                loading: true,
                searchForm: action.payload.form,
            };
        case COURRIEL_SEARCH_SUCCESS:
            return { ...state, loading: false, list: action.payload };
        case COURRIEL_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/courriel/models/courriel.store.ts